import React, { useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card
} from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import IconHeader from "../../images/logo.png";
import { AiOutlineEdit } from "react-icons/ai";
import "./style.scss";

function TwoFactorOTP() {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "user@example.com";
  const otpContainerRef = useRef<any>(null);

  const handleOtpChange = (otpValue: string) => {
    if (/^\d{0,6}$/.test(otpValue)) {
      setOtp(otpValue);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (otp.length !== 6) {
      toast.error("Please enter a 6-digit OTP", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    setLoading(true);

    // Simulate OTP verification
    setTimeout(() => {
      toast.success("OTP verified successfully!", {
        position: toast.POSITION.TOP_RIGHT
      });

      navigate("/subscription", { replace: true });
      setLoading(false);
    }, 1000);
  };

  const handleResendOtp = () => {
    setOtp(""); // Clear the OTP inputs
    
    // Focus the first input after clearing
    setTimeout(() => {
      const firstInput = document.querySelector('.otp-container input:first-child') as HTMLInputElement;
      if (firstInput) {
        firstInput.focus();
      }
    }, 50);
    
    toast.success("OTP sent to your email!", {
      position: toast.POSITION.TOP_RIGHT
    });
  };

  return (
    <section className="dashboard credential-page">
      <Container fluid>
        <Row className="justify-content-md-center">
          <Col xl={5} lg={10} md={12} sm={12}>
            <Card className="px-5 pt-4 pb-5" style={{ borderRadius: "16px" }}>
              <figure className="text-center">
                <img src={IconHeader} alt="logo" width={250} />
                <h2>Two-Factor Authentication</h2>
                <div className="email-display mb-3">
                  <p className="mb-1">OTP sent to:</p>
                  <div className="d-flex align-items-center justify-content-center">
                    <span>{email}</span>
                    <Button 
                      variant="link" 
                      // size="sm" 
                      className="p-1 ms-2 text-primary"
                      onClick={() => navigate("/", { replace: true })}
                    >
                      <AiOutlineEdit />
                    </Button>
                  </div>
                </div>
              </figure>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4 text-center">
                  <Form.Label className="mb-3">
                    Enter 6-digit OTP<sup>*</sup>
                  </Form.Label>
                  <div className="d-flex justify-content-center">
                    <OtpInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      shouldAutoFocus
                      containerStyle="otp-container"
                      inputStyle={{
                        background: "#fff",
                        height: "60px",
                        width: "60px",
                        fontSize: "24px",
                        color: "#333",
                        fontWeight: "600",
                        caretColor: "#08A45D",
                        textAlign: "center",
                        border: "2px solid #e0e0e0",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        marginRight: "12px"
                      }}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>
                </Form.Group>

                <Button
                  variant="primary"
                  className="mt-2 border-0 text-white font-16 w-100 py-3 gilroy-semibold"
                  type="submit"
                  size="lg"
                  disabled={loading || otp.length !== 6}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </Button>

                <div className="text-center mt-3">
                  <p className="mb-2">Didn't receive the OTP?</p>
                  <Button
                    variant="link"
                    className="p-0 text-primary"
                    onClick={handleResendOtp}
                  >
                    Resend OTP
                  </Button>
                </div>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TwoFactorOTP;